<script setup>
const route = useRoute()
const {slugify, locationSharedContent, locationLeadGen, locationShortForm, locationDockedNavigation, locationFetch, transformFetch, trustPilotReviews, transformTrustPilot} = useLocationData()
const { leadGenData } = useLeadGenData();
const {setPageHead} = useGlobalFeaturesData();

// Getting the location slug and the state slug to verify the authenticity  of the page
const state = route.params.state;
const location = route.params.locationData;
const error = route.params.locationError;
const startTime = new Date().getTime();
if (error) {
  throw createError({ statusCode: 404, statusMessage: "Page not found!" })
}

let preview = route.query.preview
if (!preview && location.value.entity.publishedAt == null) {
  throw createError({ statusCode: 404, statusMessage: "Page not found!" })
}

// Cheking state or country in case of intl location
if (!state.includes(slugify(location.value.entity.pulseLocation.address.state)) || (state === 'international-summer-camps' && location.value.entity.pulseLocation.address.country === 'United States')) {
  throw createError({ statusCode: 404, statusMessage: "Page not found!" })
}

// Cheking state or country in case of intl location
if (!state.includes(slugify(location.value.entity.pulseLocation.address.state)) || (state === 'international-summer-camps' && location.value.entity.pulseLocation.address.country === 'United States')) {
  throw createError({ statusCode: 404, statusMessage: "Page not found!" })
}

function cleanTags(tags) {
  let newTags = []
  for (let i = 0; i < tags.length; i++) {
    newTags.push(tags[i].tag)
  }
  return newTags
}

const { data: response, pending } =  await useAsyncData('locationRequest', async () => {
  try {
    const [sharedContent, shortForm, locationForm, leadGen, dockedNav] = await Promise.all([
      locationFetch('locationSharedContent'),
      locationFetch('locationShortForm'),// locationShortForm(),
      locationFetch('locationLeadGen'),// locationLeadGen(),
      locationFetch('leadGenData'),// leadGenData(),
      locationFetch('locationDockedNavigation'), // locationDockedNavigation()      
    ])
    
    return { 
      sharedContent: transformFetch('locationSharedContent', sharedContent), 
      shortForm: transformFetch('locationShortForm', shortForm), 
      locationForm: transformFetch('locationLeadGen', locationForm), 
      leadGen: transformFetch('leadGenData', leadGen), 
      dockedNav: transformFetch('locationDockedNavigation', dockedNav),      
    }
  }
  catch (error) {
    console.error('Error fetching location data', error)
    return { error: error }
  }
  
})

// Getting the Location shared content once we have verified the page is legit
// const {data: sharedContent} = await locationSharedContent()
const sharedContent = response.value.sharedContent;

// Getting the Location shared content once we have verified the page is legit
// const {data: shortForm} = await locationShortForm();
const shortForm = response.value.shortForm;


// Getting the long form global configuration
// const locationForm = await locationLeadGen()
const locationForm = response.value.locationForm;
const leadGenForm = locationForm.leadGenForm

// Getting the long form global configuration
if (!!location.value.entity.locationTagsArray && location.value.entity.locationTagsArray.length > 0){
  leadGenForm.tagsArray = cleanTags(location.value.entity.locationTagsArray)
} else {
  leadGenForm.tagsArray = cleanTags(locationForm.tagsArray)
}

leadGenForm.locationId = location.value.entity.pulseId
leadGenForm.locationName = location.value.entity.pulseLocation.name

// Ribbon form tags array
const brochureRibbonTags = location.value.entity.tagsArray ? location.value.entity.tagsArray : [];

// Getting Lead Gen fields
// const { data: leadGen } = await leadGenData();
const leadGen = response.value.leadGen;

// Getting Lead Gen fields
// const { data: dockedNav } = await locationDockedNavigation();
const dockedNav = response.value.dockedNav;

const {data: trustPilot} = await trustPilotReviews();
const tpReviews = transformTrustPilot(trustPilot, 'All');

// Knowing when Get more info and Sign up buttons are clicked

const handleGetMoreInfo = () => {
  // Add logic here for 'Get more info' button
}

const { urlRegisterFunction } = useUtils();

const handleSignUp = () => {
  // Scroll to element
  const offset = document.getElementById('www-spa-container').offsetTop;
  const deviceOffset = screen.width >= 992 ? 80 : 0;
  const scrollTopTo = offset - 130 - deviceOffset;  
  window.scrollTo({
    top: scrollTopTo,
    behavior: 'smooth',
  });
}
// Set meta tags in head for SEO
if(location.value && location.value.entity && location.value.entity.seo) {
  setPageHead(location.value.entity.seo, route.path);
}

</script>

<template>
  <UIModal modalId="get-more-info" modalClass="lead-gen-modal modal-dialog-scrollable" modalTitle="">
    <LayoutLongForm :leadGenForm="leadGenForm" :leadTypeID="'67009'" :isModal="true"/> <!-- Lead type ID for location page -->
  </UIModal>
  <LocationHeroSection :sharedContent="sharedContent" :location="location.entity" :leadGen="leadGen" :shortForm="shortForm" :trustPilotReviews="tpReviews" />
  <LocationSubMenu :location="location.entity" @onSignUpClick="handleSignUp" :navLabels="dockedNav" :showPromoBanner="route.params.showPromoBanner"/>
  <div data-bs-spy="scroll" data-bs-target="#location-navbar" data-bs-offset="0" class="scrollspy" tabindex="0" id="location-page-components">
    <LayoutDynamicComponents v-if="location.entity.overview.length > 0" :sections="location.entity.overview" id="overview" :location="location.entity.pulseLocation"/>
    <LocationAVC :location="location.entity" v-if="location.entity.pulseLocation.status.typeId == 1 " :showPromoBanner="route.params.showPromoBanner" />
    <LocationMap :currentLocation="location.entity.id" :nearby="location.nearest" :locations="location.locations" :mapContent="location.entity.mapContent" :sectionTitle="location.entity.mapTitle" />
    <LayoutDynamicComponents v-if="location.entity.campusLife.length > 0" :sections="location.entity.campusLife" :location="location.entity.pulseLocation" id="campusLife"/>
    <LayoutDynamicComponents v-if="location.entity.instructors.length > 0" :sections="location.entity.instructors" id="instructors" :location="location.entity.pulseLocation"/>
    <LayoutDynamicComponents v-if="location.entity.faqs.length > 0" :sections="location.entity.faqs" id="faqs" :location="location.entity.pulseLocation"/>
  </div>  
  <LayoutRibbonForm v-if="location.entity.brochureRibbon" :ribbonTags="brochureRibbonTags" />
  <LayoutBackToTop v-if="location.entity.jumpToTop"/>
  <ChatService v-if="location.entity.showChatService"/>
</template>
